import React from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";

import { useLogout } from "components/use-hooks";


const MainMenuApp = ( { action } ) => {

    const { logout } = useLogout();

    return(
        <nav className="main-menu-wrap">
            <ul className="main-menu">
                <li>
                    <Link to="/locations/" onClick={ action }>Locations</Link>
                </li>
                <li>
                    <Link to="/company/" onClick={ action }>Company</Link>
                </li>
                <li>
                    <Link to="/company/my-profile/" onClick={ action }>My profile</Link>
                </li>
                <li>
                    <Button
                        onClick={ () => logout({ redirectRoute: "/" }) }
                        type="link"
                    >
                        Logout
                    </Button>
                </li>
            </ul>
        </nav>
    );
};

export default MainMenuApp;
